export default __webpack_public_path__ + "7da120d95050ceb6db30e113c1e97c57.png";